// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selection-on-snippet-color {
  background: var(--AA-gloabl-bg-secondary);
}
.selection-on-snippet-color ul li {
  background: var(--AA-global-white-color);
}
.selection-on-snippet-color .source-count-num {
  color: var(--AA-global-white-color);
  background: var(--AA-global-theme-bg);
  display: inline-block;
  padding: 0px 5px;
  border-radius: 100%;
  min-width: 18px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/suggestions/snippet/snippet.scss"],"names":[],"mappings":"AAAA;EACI,yCAAA;AACJ;AACQ;EACI,wCAAA;AACZ;AAEI;EACI,mCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAAR","sourcesContent":[".selection-on-snippet-color{\n    background: var(--AA-gloabl-bg-secondary);\n    ul{\n        li{\n            background: var(--AA-global-white-color);\n        }\n    }\n    .source-count-num{\n        color: var(--AA-global-white-color);\n        background: var(--AA-global-theme-bg);\n        display: inline-block;\n        padding: 0px 5px;\n        border-radius: 100%;\n        min-width: 18px;\n        text-align: center;\n    }\n}   "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
